import Route from '@ember/routing/route';
import { inject as service } from '@ember/service';
import { trackPageViewFromTransition } from 'sh-www/utils/datalayer';

/** @module */
class SettingsPasswordResetRoute extends Route {
  @service session;

  /** @inheritDoc */
  activate(transition) {
    super.activate(...arguments);
    this.controllerFor('settings').set('newSettingsPage', true);
    trackPageViewFromTransition(this, transition, '/settings/credentials/');
  }

  /** @inheritDoc */
  deactivate() {
    super.deactivate(...arguments);
    this.controllerFor('settings').set('newSettingsPage', false);
  }

  setupController(controller) {
    super.setupController(...arguments);

    controller.loadUserOAuthProviders.perform();
    controller.loadUserSamlProviders.perform();
  }

  resetController(controller, isExiting) {
    super.resetController(...arguments);
    if (isExiting) {
      controller.loadUserOAuthProviders.cancelAll({ resetState: true });
      controller.loadUserSamlProviders.cancelAll({ resetState: true });
    }
  }
}

export default SettingsPasswordResetRoute;
